/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: generate-accept-profile-modal-component.ts
 *
 * Created by kyang on 2021-01-26.
 */

function GenerateAcceptProfileModalController(
    this: JS5Object,
    _: JS5Object,
    $filter: JS5Function,
    $q: JS5Object,
    MediaAcceptProfileService: JS5Object,
    MediaInfoService: JS5Object,
    VALID_FILE_EXTENSIONS: JS5Object,
) {

    //========================//
    // Remote File Validation //
    //========================//

    this.getFileExtensions = () => {
        return VALID_FILE_EXTENSIONS[this.mediaAcceptProfileType];
    };

    this.validateRemoteFile = (fileSystemItem: JS5Object) => {
        let virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return $q.when({
            source: virtualPath,
            errors: [],
            warnings: [],
        });
    };


    //=======================//
    // Local File Validation //
    //=======================//

    this.getLocalFilePreValidationErrors = (file: File, filter: JS5Object) => {
        // Doesn't add any local file filters
    };

    this.validateLocalFile = (fileItem: JS5Object) => {
        return MediaInfoService.executeMediaInfo(fileItem._file)
            .then((mediaInfoXml: string) => {
                return {
                    source: fileItem.file.name,
                    errors: [],
                    warnings: [],
                    mediaInfoXml: mediaInfoXml,
                };
            })
            .catch((errorData: any) => {
                return {
                    source: fileItem.file.name,
                    errors: [{
                        source: fileItem.file.name,
                        description: `Failed to run MediaInfo: ${JSON.stringify(errorData)}`,
                        severity: 'ERROR',
                    }],
                    warnings: [],
                };
            });
    };


    //===================//
    // Template Response //
    //===================//

    this.onCancelClicked = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.onOkClicked = (buttonFile: JS5Object) => {
        let updateValidatorsPromise: JS5Promise;
        this.loadingIndicator.show = true;
        switch (buttonFile.type) {
            case 'LOCAL':
                updateValidatorsPromise = MediaAcceptProfileService.updateValidatorsFromMediaInfo(
                    this.mediaAcceptProfileId, buttonFile.results[0].mediaInfoXml
                );
                break;
            case 'REMOTE':
                updateValidatorsPromise = MediaAcceptProfileService.updateValidatorsFromMedia(
                    this.mediaAcceptProfileId, buttonFile.files[0].virtualPath
                );
                break;
        }
        updateValidatorsPromise.then(() => {
            this.close();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.mediaAcceptProfileType = this.resolve.mediaAcceptProfileType;
        this.mediaAcceptProfileId = this.resolve.mediaAcceptProfileId;
        this.typeName = (this.mediaAcceptProfileType === 'OTHER') ? 'ARTWORK' : this.mediaAcceptProfileType;
        this.dropZoneLabel = `Drop ${$filter('capitalize')(this.typeName)} File Here`;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };

    this.initializeLocalUploaderConfig = (fileUploaderConfig: JS5Object) => {
    };
}

angular
    .module('prism-ui.components')
    .component('generateAcceptProfileModal', {
        templateUrl: 'components/modal/generateAcceptProfileModal/generate-accept-profile-modal-template.html',
        controller: GenerateAcceptProfileModalController,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
